<template>
  <div :class="$route.fullPath!='/home'?'footer':'footer-bg'">
    <div class="container w">
      <div class="footer-menu">
        <div class="footer-left">
          <h3>尊敬的用户，您好!</h3>
          <p>医小智为您带来全新的齿科在线设计服务，不管您什么时间需要，多远的距离需要，都可以在医小智享受专业高效的义齿设计服务。1分钟完成下单，5分钟反馈数字化扫描数据品质，实时更新临床信息，30分钟完成数字化线上设计，输出制造文件和治疗方案，24小时内免费修改设计方案。我们的目标是帮助您及您的客户打造一口健康、美丽的牙齿，让您自信地展开笑容!</p>
        </div>
        <div class="footer-right">
          <ul>
            <li class="items-group">
              <h3>软件中心</h3>
              <div class="item-name">
                <a @click.prevent="openAgree('23')">在线软件</a>
                <a @click.prevent="openAgree('24')">软件下载</a>
                <a @click.prevent="openAgree('21')">合作介绍</a>
                <a @click.prevent="openAgree('25')">医患沟通应用介绍</a>
              </div>
            </li>
          </ul>
          <ul>
            <li class="items-group">
              <h3>产品中心</h3>
              <div class="item-name">
                <a @click.prevent="openAgree('12')">设计说明</a>
                <a @click.prevent="openAgree('13')">售后服务</a>
                <a @click.prevent="openAgree('15')">下单操作流程</a>
                <a @click.prevent="openAgree('16')">接单操作流程</a>
                <a @click.prevent="openAgree('17')">种植模块说明</a>
                <a @click.prevent="openAgree('18')">固定模块说明</a>
              </div>
            </li>
          </ul>

          <ul>
            <li class="items-group">
              <h3>齿科学院</h3>
              <div class="item-name">
                <a @click.prevent="openAgree('31')">联系方式</a>
                <a @click.prevent="openAgree('32')">企业招聘</a>
                <a @click.prevent="openAgree('33')">荣誉奖项</a>
                <a @click.prevent="openAgree('34')">线上培训</a>
                <a @click.prevent="openAgree('35')">线下培训</a>
              </div>
            </li>
          </ul>

          <ul>
            <li class="items-group">
              <h3>联系我们</h3>
              <div class="item-name">
                <a @click.prevent="openAgree('41')">有关医小智</a>
                <a @click.prevent="openAgree('43')">投诉与反馈</a>
                <a @click.prevent="openAgree('44')">在线客服</a>
              </div>
            </li>
          </ul>
        </div>

<!--        <div class="footer-service">

          <div class="tel">
            400 088 3316
          </div>

          <div class="time">
            每天 8:30 ~ 21:30
          </div>

          <div class="online">
            <y-button text="在线帮助" class="button" @btnClick="openService"></y-button>
          </div> -->

        </div>
      </div>

      <div class="footer-info">

        <ul class="copyright clearfix">
          <li>Copyright © 2022 医小智（日照）工业互联网有限公司 版权所有</li>
      <!--    <li><ahref="" >隐私政策</a></li>
          <li><ahref="" >用户协议</a></li>
          <li><ahref="" >资质证照</a></li> -->
        </ul>

        <ul class="icp">
          <li>
            <!-- <a href="http://beian.miit.gov.cn">鲁ICP备 2022031907号-1</a> -->
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37110202371204" rel="noreferrer" target="_blank">鲁公网安备37110202371204</a>
          </li>
         <li class="public-security">
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033469">
              <!-- （鲁）经营性-2022-0192 -->
              鲁B2-20240306
            </a>
          </li>
          <li>
            <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2022031907号-1</a>
          </li>
        </ul>

      </div>

    </div>

  </div>
</template>
<script>
  import YButton from '/components/YButton'
  export default {
    data() {
      return {}
    },
    methods: {
      openService() {
        this.$notify({
          title: '离线帮助',
          message: '系统正在维护中，暂时无法为您提供帮助，如有紧急事项请联系400 088 3316',
          type: 'warning'
        })
      },
     openAgree(id) {
       if(id==24){
        let routeUrl = this.$router.resolve({path: '/downLoad'})
        window.open(routeUrl.href, '_blank');
       }else{
         let url = this.$router.replace({
         	name:'agreement',
         	query: {agreeId:id},
         })
         window.open(url,'_self')
       }
     }
     /*
      openAgree(id) {
        // window.open('//' + window.location.host + '/#/agreement?agreeId=' + id)
      	let url = this.$router.replace({
      		name:'agreement',
      		query: {agreeId:id},
      	})
      	window.open(url,'_self')
      }
     */
    },
	watch: { '$route' (to, from) {
			window.location.reload();
		},
	},
    components: {
      YButton,
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  .container {}

  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .footer-bg{
    background: url(/static/images/square.png);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer-menu {
    position: relative;
    overflow: hidden;
    padding: 50px 0 20px;
    border-bottom: 1px solid #e6e6e6;
    // border: 1px solid #ff9900;
  }

  .footer-menu a {
    color: #666;
    cursor: pointer;
    transition: all .15s ease-out;
    text-decoration: none;
  }

  .footer-menu h1 {
    display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  .footer-menu h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }

  .footer-menu h3 {
    color: #646464;
    font-weight: 600;
    font-size: 15px;
    padding: 0 0 20px;
  }

  .footer-menu .items-group {
    float: left;
    margin-left: 50px;
    line-height: 1;
  }

  .footer-menu .items-group .item-name a {
    display: block;
    color: #4a86e8;
    font-size: 12px;
    padding: 7px 0;
  }

  .footer-menu .footer-service {
    position: absolute;
    right: 0;
    overflow: hidden;
    line-height: 38px;
    text-align: right;
  }

  .footer-menu .footer-service .tel {
    position: relative;
    font-size: 22px;
    font-weight: 800;
    line-height: 1;
    cursor: default;
    color: #00a5d5;
  }

  .footer-menu .footer-service .time {
    margin: 15px 0;
    font-size: 12px;
    line-height: 1;
    color: #999;
  }

  .online {
    clear: both;
    width: 241px;
    font-size: 12px;
    line-height: 18px;
    color: #c3c3c3;
    text-align: right;

    .button {
      color: #00a5d5;
      font-weight: 700;
    }
  }

  .footer-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #434d55;
    font-size: 12px;
    padding: 20px 0 30px;
  }

  .footer-info .copyright{
  }

  .footer-info .copyright li:first-child {
    padding-left: 0;
    border-left: none;
  }

  .footer-info .copyright li {
    float: left;
    line-height: 12px;
    color: #bdbdbd;
    padding: 0 10px;
    border-left: 1px solid #ccc;
  }

  .footer-info .copyright li a {
    color: #ababab;
    cursor: pointer;
    -webkit-transition: all .15s ease-out;
    transition: all .15s ease-out;
  }

  .footer-info .icp {
    margin-top: 10px;
  }

  .footer-info .icp li {
    float: left;
    line-height: 12px;
    padding-right: 10px;
  }

  .footer-info .icp li+li {
    border-left: 1px solid #ccc;
    padding-left: 10px;
  }

  .footer-info .public-security {
    position: relative;
    padding-left: 35px !important;
  }

  .footer-info .icp li a {
    color: #bdbdbd;
    cursor: pointer;
    -webkit-transition: all .15s ease-out;
    transition: all .15s ease-out;
  }

  .footer-info .public-security:before {
    position: absolute;
    content: "";
    top: -5px;
    left: 10px;
    width: 20px;
    height: 20px;
    background: url('/static/images/icon-public-security.png') no-repeat;
    background-size: 20px;
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }
  .footer-right{
  }
  .footer-left{
    width: 40%;
    height: 200px;
    margin-right: 20%;
    // border: 1px solid khaki;
    float: left;
    p{
      line-height: 25px;
      letter-spacing:0.5px;
    }
    .item-name{
      a{
        color:red;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MFooter.vue?75f0ab74